import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { PrimaryButton } from "./ui";

const LINKS = [
  { label: "How it works", href: "#how" },
  { label: "Safety", href: "#safety" },
  { label: "The App", href: "#app" },
  { label: "Routes", href: "#routes" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-[#12142b]/10 bg-white/80 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-12">
        <a href="#top" data-testid="logo" className="flex items-center gap-2">
          <img src="/saferide-logo.png" alt="SafeRide" className="h-8 w-auto transition-transform duration-300 hover:scale-105" />
        </a>

        <ul className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-${l.href.slice(1)}`}
                className="group relative font-display text-sm font-medium text-[#565b73] transition-colors hover:text-[#12142b]"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-0.5 w-0 bg-[#2340b5] transition-all duration-300 group-hover:w-full" />
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <PrimaryButton testId="nav-download-btn" className="!px-6 !py-3">
            Get the App
          </PrimaryButton>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="text-[#12142b] md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden border-t border-[#12142b]/10 bg-white md:hidden"
          >
            <ul className="flex flex-col gap-2 px-6 py-6">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block py-2 font-display text-lg font-medium text-[#12142b]"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li className="pt-4">
                <PrimaryButton testId="mobile-download-btn" className="w-full">
                  Get the App
                </PrimaryButton>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
